import { Component, OnInit } from '@angular/core';
//import * as socketIo from 'socket.io-client';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
}) 
  
 
export class AppComponent implements OnInit {

  constructor(){
  }
  public homediv:boolean=true; 
   
  
  ngOnInit(){
   //var socket = socketIo('http://server.khanehaval.com');
   //socket.on('connect', function () {
    //console.log('connected  in site side!');
    //socket.emit('hello', { message: 'Site Side !' });
   //});
   
   //socket.on("hello", (data) => {
    //console.log(data);
   //});
  }
}
